export const getCustomCommandDataError = () => '';
